var _templateObject = _taggedTemplateLiteralLoose(['\n  align-items: flex-end;\n  background-color: rgba(255, 255, 255, 0.9);\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 2;\n'], ['\n  align-items: flex-end;\n  background-color: rgba(255, 255, 255, 0.9);\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 2;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background: #fff;\n  border: 1px solid #b9bbc2;\n  margin-bottom: 20px;\n  max-width: 90%;\n  padding: 1rem;\n'], ['\n  background: #fff;\n  border: 1px solid #b9bbc2;\n  margin-bottom: 20px;\n  max-width: 90%;\n  padding: 1rem;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

var Wrapper = styled.div(_templateObject);

var Body = styled.div(_templateObject2);

var DeleteCardOverlay = function DeleteCardOverlay(props) {
  return React.createElement(
    Wrapper,
    null,
    props.hasPurchases ? React.createElement(
      Body,
      null,
      React.createElement(
        'p',
        null,
        'This post has purchases and can not be deleted.'
      ),
      React.createElement(
        'div',
        { style: { textAlign: 'right' } },
        React.createElement(
          'button',
          {
            className: 'btn btn-primary px-3 py-1 mb-3',
            onClick: props.cancelFn
          },
          'Cancel'
        )
      )
    ) : React.createElement(
      Body,
      null,
      React.createElement(
        'p',
        null,
        'Delete this ',
        props.cardType,
        '?'
      ),
      React.createElement(
        'a',
        {
          className: 'btn btn-danger text-white mr-3 px-3 py-1 mb-3',
          onClick: props.deleteFn
        },
        'Yes, Delete'
      ),
      React.createElement(
        'a',
        { className: 'btn btn-link px-3 py-1 mb-3', onClick: props.cancelFn },
        'Cancel'
      ),
      React.createElement(
        'div',
        null,
        'Caution: this can not be undone.'
      )
    )
  );
};

DeleteCardOverlay.propDefaults = {
  hasPurchases: false
};

DeleteCardOverlay.propTypes = process.env.NODE_ENV !== "production" ? {
  cancelFn: PropTypes.func.isRequired,
  cardType: PropTypes.string.isRequired,
  deleteFn: PropTypes.func.isRequired,
  hasPurchases: PropTypes.bool
} : {};

export default DeleteCardOverlay;


//////////////////
// WEBPACK FOOTER
// ../ui-components/es/social/DeleteCardOverlay.js
// module id = 771
// module chunks = 4